import cn from "classnames";

import { TextTruncate } from "../../textTruncators/TextTruncators";
import Logo from "../../../images/brainstorm-pack-logo.png";

import "./packPublisherInfo.scss";
import { isBrainStorm } from "../../../utils/accountUtils";

export interface PackPublisherInfoProps {
  publisherName: string;
  disabled?: boolean;
}

export const PackPublisherInfo: React.FC<PackPublisherInfoProps> = (props) => {
  const { publisherName, disabled } = props;

  const renderContent = () => {
    if (publisherName) {
      const publishedBy = `By ${publisherName}`;
      return (
        <div className={cn("pack-publisher-info-container", { disabled })}>
          {isBrainStorm(publisherName) && (
            <div className="pack-publisher-logo">
              <img src={Logo} className="pack-publisher-logo-center" alt="BrainStorm Logo" />
            </div>
          )}
          <div className="pack-publisher-name">
            <TextTruncate>{publishedBy}</TextTruncate>
          </div>
        </div>
      );
    }
    return null;
  };

  return renderContent();
};
